// extracted by css-extract-rspack-plugin
export default {"input":"SectionedInput_input__zR2Rt"};